import { makeStyles } from '@material-ui/core/styles'
import { INTERACTIVE_CARD_HOVER_BOX_SHADOW } from 'lib/styles/interactive-card-hover'
import {
  DASHBOARD_BODY_TEXT,
  DASHBOARD_SURFACE_MUTED,
} from 'pages/pga-coach/dashboard/dashboard-colors'

const useStyles = makeStyles(theme => ({
  section: {
    marginTop: theme.spacing(4),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: DASHBOARD_BODY_TEXT,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    alignItems: 'stretch',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3, 1.5),
    borderBottom: '1px solid #E0E0E0',
  },
  cardHeaderLeft: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  iconCircle: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: DASHBOARD_SURFACE_MUTED,
    color: DASHBOARD_BODY_TEXT,
    marginTop: 2,
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },
  cardTitleBlock: {
    minWidth: 0,
  },
  cardTitle: {
    color: DASHBOARD_BODY_TEXT,
    marginBottom: theme.spacing(0.25),
  },
  cardSubtitle: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },
  cardHeaderRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    flexShrink: 0,
    gap: theme.spacing(0.25),
  },
  revenueTotal: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.2,
    color: DASHBOARD_BODY_TEXT,
  },
  headerBalanceSpacer: {
    minHeight: 40,
    minWidth: 1,
  },
  cardBody: {
    padding: theme.spacing(1, 3, 1.5),
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  cardMain: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
  },
  chartArea: {
    height: 148,
    minHeight: 148,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexShrink: 0,
  },
  chartEmpty: {
    height: 148,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
    fontSize: '12px',
    lineHeight: '18px',
    textAlign: 'center',
    padding: theme.spacing(0, 2),
  },
  chartError: {
    height: 148,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.error.main,
    fontSize: '12px',
    lineHeight: '18px',
    textAlign: 'center',
    padding: theme.spacing(0, 2),
  },
  loading: {
    margin: theme.spacing(3),
  },
  donutLayout: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  donutChart: {
    width: 120,
    height: 120,
    flexShrink: 0,
  },
  legend: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2.5),
    minWidth: 0,
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: DASHBOARD_BODY_TEXT,
  },
  legendSwatch: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0,
  },
  insightTip: {
    marginTop: theme.spacing(1.5),
    flexShrink: 0,
  },
  insightTipCopy: {
    alignItems: 'center',
  },
  insightTipIcon: {
    alignSelf: 'center',
    lineHeight: 1,
  },
  chartTooltip: {
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    boxShadow: INTERACTIVE_CARD_HOVER_BOX_SHADOW,
    padding: theme.spacing(1, 1.5),
    minWidth: 120,
  },
  chartTooltipLabel: {
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 600,
    color: DASHBOARD_BODY_TEXT,
    marginBottom: theme.spacing(0.25),
  },
  chartTooltipValue: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
